import React from 'react'
import { SkeletonLoader } from '@ally/metronome-ui'

/* Default Skeleton Loader representing "top card" loading state */
export const AccountDetailsSkeletonLoader: React.FC = () => {
  return (
    <SkeletonLoader.Container>
      <SkeletonLoader.Row width="xl" height="l" />
      <SkeletonLoader.Row width="xl" height="l" />
    </SkeletonLoader.Container>
  )
}
